const loginID = state => state.loginID
const nexonName = state => state.nexonName
const couponCount = state => state.couponCount
const balance = state => state.balance

const couponUsable = ({ couponUsable }) => couponUsable
const couponUsableList = ({ couponUsable }) => couponUsable.couponUsableList

const couponUnusable = ({ couponUnusable }) => couponUnusable
const couponUnusableList = ({ couponUnusable }) =>
  couponUnusable.couponUnusableList

const purchase = ({ purchase }) => purchase
const purchaseList = ({ purchase }) => purchase.purchaseList

const withdraw = ({ withdraw }) => withdraw
const purchaseWithdrawList = ({ withdraw }) => withdraw.purchaseWithdrawList

const rewardInfo = ({ rewardInfo }) => rewardInfo

const alltemPurchaseProductList = ({ alltemPurchaseProductList }) =>
  alltemPurchaseProductList
const alltemPurchaseStartDate = ({ alltemPurchaseStartDate }) =>
  alltemPurchaseStartDate
const alltemPurchaseEndDate = ({ alltemPurchaseEndDate }) =>
  alltemPurchaseEndDate

export default {
  loginID,
  nexonName,
  couponCount,
  balance,
  couponUsable,
  couponUsableList,
  couponUnusable,
  couponUnusableList,
  purchase,
  purchaseList,
  withdraw,
  purchaseWithdrawList,
  rewardInfo,
  alltemPurchaseProductList,
  alltemPurchaseStartDate,
  alltemPurchaseEndDate
}
